import axios from 'axios';
import Handlers from './handlers'

const API_PATH = 'notifications/';

class NotificationsService {
    create(requestData) {
        const url = API_PATH + 'create';
        return new Promise((resolve, reject) => {
            axios.post(url, requestData)
                .then(response => {
                    // handle success
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    // handle error
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
	listFiltered(requestData) {
		const url = API_PATH + 'list_filtered';
		return new Promise((resolve, reject) => {
			axios.post(url, requestData)
				.then(response => {
					// handle success
					Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
				})
				.catch(error => {
					// handle error
					Handlers.ERROR_HANDLER(url, error, null, reject);
				});
		});
	}
	setViewed(notification) {
        const url = API_PATH + 'set_viewed';
        return new Promise((resolve, reject) => {
            axios.post(url, notification.id)
                .then(response => {
                    // handle success
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    // handle error
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
}

export default new NotificationsService();